class imageDots extends HTMLElement {
  constructor() {
    super();

    this.toggleContentHandlers = this.querySelectorAll('.js-toggle-content');

    this.toggleContentHandlers.forEach((handler) => {
      handler.addEventListener('mouseenter', this.toggleContent.bind(this));
      handler.addEventListener('mouseleave', this.toggleContent.bind(this));
      handler.addEventListener('click', this.toggleContent.bind(this));
    });
  }

  toggleContent() {
    const interactiveElements = this.querySelectorAll('.image-dots__interactive-element');

    if (
      (event.type === 'mouseenter' && window.innerWidth > 1024)
      || event.type === 'click' && window.innerWidth <= 1024
    ) {
      const currentElements = this.querySelectorAll(`.image-dots__interactive-element[data-index="${event.currentTarget.dataset.index}"]`);

      interactiveElements.forEach((element) => {
        element.classList.remove('active');
      });

      currentElements.forEach((element) => {
        element.classList.add('active');
      });
    } else if (event.type === 'mouseleave' && window.innerWidth > 1024) {
      interactiveElements.forEach((element) => {
        element.classList.remove('active');
      });
    }
  }
}

customElements.define('image-dots', imageDots);
